import { lazy } from "react";

function lazyLoadNamed(path, exportName) {
  return lazy(() =>
    import(`../${path}`).then((module) => {
      // Check if the named export exists
      if (!(exportName in module)) {
        console.error(`Export "${exportName}" not found in module "${path}"`);
        return { default: () => null }; // Fallback component
      }
      return { default: module[exportName] };
    })
  );
}

const lazyLoad = (path) => {
  return lazy(() =>
    import(`../${path}`).then((module) => {
      if (!module.default) {
        console.error(`Default export not found in module "${path}"`);
        return { default: () => null }; // Fallback component
      }
      return module;
    })
  );
};

export const pages = {

  SignupPage: lazyLoadNamed("pages/studentpages/signup/signuppage/Signup", "SignupPage"),
  LoginPage: lazyLoadNamed("pages/studentpages/login/loginpage/Login", "LoginPage"),
  LoginOtpPage: lazyLoadNamed("pages/studentpages/login/loginOTP/LoginOtp", "LoginOtpPage"),
  PersonalInfoPage: lazyLoadNamed("pages/studentpages/signup/personalInformation/PersonalInfo.jsx", "PersonalInfoPage"),
  PersonaldocumentsPage: lazyLoadNamed("pages/studentpages/signup/personaldocumemts/Personaldocuments.jsx", "PersonaldocumentsPage"),
  AcademicInfoPage: lazyLoadNamed("pages/studentpages/signup/educationDetails/AcademicInfo.jsx", "AcademicInfoPage"),
  LetsContinuePage: lazyLoadNamed("pages/studentpages/signup/letContinue/LetsContinue.jsx", "LetsContinuepage"),
  EditPersonaldocumentsPage: lazyLoadNamed("pages/studentpages/studentNewPortfolio/editPersonaldocuments/EditPersonaldocuments .jsx", "EditPersonaldocumentsPage"),

  LetsBeginPage: lazyLoadNamed("pages/poPages/auth/letsBegin/LetsBegin.jsx", "LetsBeginPage"),
  HrSignupPage: lazyLoadNamed("pages/hrPage/auth/hrLetBegin/LetBegin", "HrLetsBeginPage"),
  HrLoginPage: lazyLoadNamed("pages/hrPage/auth/Login", "HrLoginPage"),
  HrCreatePassPage: lazyLoadNamed("pages/hrPage/auth/CreatePass.jsx", "HrCreatePassPage"),
  HrCompanyInfo1Page: lazyLoadNamed("pages/hrPage/newCompany/CompanyInfo1", "HrCompanyInfo1Page"),
  HrCompanyInfo2Page: lazyLoadNamed("pages/hrPage/newCompany/CompanyInfo2.jsx", "HrCompanyInfo2Page"),
  HrCompanyInfo3Page: lazyLoadNamed("pages/hrPage/newCompany/CompanyInfo3", "HrCompanyInfo3Page"),
  HrCompanyInfo4Page: lazyLoadNamed("pages/hrPage/newCompany/CompanyInfo4", "HrCompanyInfo4Page"),
  HrCompanyAddressPage: lazyLoadNamed("pages/hrPage/newCompany/CompanyAddress.jsx", "HrCompanyAddressPage"),
  HrContactPage: lazyLoadNamed("pages/hrPage/contact/Contactinfo.jsx", "HrContactPage"),
  HrHavingIssuePage: lazyLoadNamed("pages/hrPage/havingissue/HavingIssue", "HrHavingIssuePage"),
  EditCompanyProfile:lazyLoad("pages/hrPage/dashboard/profileScreen/EditCompanyProfile","EditCompanyProfile"),
  HavingIssuePo: lazyLoadNamed("pages/poPages/havingissue/HavingIssue", "HavingIssuePage"),
  BillingPage: lazyLoadNamed("pages/poPages/subscriptions/billing/Billing", "BillingPage"),
  CollegeInfoPage: lazyLoadNamed("pages/poPages/personalDoc/collegeInfo/CollegeInfo", "CollegeInfoPage"),
  CollegeAddressPage: lazyLoadNamed("pages/poPages/personalDoc/collegeInfo/CollegeAddress", "CollegeAddressPage"),
  ContactInfoPage: lazyLoadNamed("pages/poPages/personalDoc/contactInfo/ContactInfo", "ContactInfoPage"),
  CollegeAcademicInfoPage: lazyLoadNamed("pages/poPages/collegeAcademicInfo/CollegeAcademicInfo", "CollegeAcademicInfoPage"),
  Pricing: lazyLoad("pages/poPages/subscriptions/pricing/Pricing"),
  PayemntPage: lazyLoad("pages/poPages/subscriptions/Subscription.jsx"),
  PortfolioProjects: lazyLoad("pages/studentpages/portfollioprojects/PortfollioProjects.jsx"),
  SslcDetailsPage1: lazyLoadNamed("pages/studentpages/educationInfo/sslcDetails/sslcDetail1/SslcDetails.jsx", "SslcDetailsPage1"),
  SslcDetailsPage2: lazyLoadNamed("pages/studentpages/educationInfo/sslcDetails/sslcDetail2/SslcDetails2.jsx", "SslcDetailsPage2"),
  HscDetailsPage1: lazyLoadNamed("pages/studentpages/educationInfo/hscDetails/hscDetail1/HscDetails.jsx", "HscDetailsPage1"),
  HscDetailsPage2: lazyLoadNamed("pages/studentpages/educationInfo/hscDetails/hscDetail2/HscDetails2.jsx", "HscDetailsPage2"),
  DegreePage1: lazyLoadNamed("pages/studentpages/educationInfo/degreeDetails/degreeDetails1/Degree1.jsx", "DegreePage1"),
  DegreePage2: lazyLoadNamed("pages/studentpages/educationInfo/degreeDetails/degreeDetails2/Degree2.jsx", "DegreePage2"),
  HavingIssues: lazyLoadNamed("pages/commanPages/havingIssue/HavingIssues.jsx","HavingIssuesPage"),
  LandingPage: lazyLoad("pages/landingPage/Index"),
  ContactUs: lazyLoad("pages/landingPage/contactus/ContactUs"),
  AboutUs: lazyLoad("pages/landingPage/aboutus/AboutUs"),
  SelectRole: lazyLoad("pages/landingPage/rolesSection/Index.jsx"),
  PageNotFound: lazyLoad("pages/handlingPages/pageNotFound/pageNotFound"),
  AccessDeniedIndex: lazyLoad("pages/handlingPages/pageNotFound/pageAccessDenied.jsx"),
  NotAuthorized: lazyLoad("pages/handlingPages/notAuthorized/notAuthorized"),
  PoDashboardIndex: lazyLoad("pages/poPages/dashboard/PoDashboardIndex.jsx"),


  HrDashboardIndex: lazyLoad("pages/hrPage/dashboard/HrDashboardIndex"),
  ResetPasswordPage: lazyLoadNamed("pages/commanPages/resetPassword/ResetPassword.jsx", "ResetPasswordPage"),
  ResetOtpPage: lazyLoadNamed("pages/commanPages/resetPassword/Otp.jsx", "ResetOtpPage"),
  NewCreatePassPage: lazyLoadNamed("pages/commanPages/resetPassword/NewPassword.jsx", "NewCreatePassPage"),

  NewLoginPage: lazyLoad("pages/commanPages/login/Login.jsx"),
  CreatePassPage: lazyLoadNamed("pages/commanPages/createPass/CreatePass.jsx", "CreatePassPage"),
  CommonOtpPage: lazyLoadNamed("pages/commanPages/otp/CommonOTP.jsx", "OtpPage"),
  
  StudentPortfolioIndex: lazyLoad("pages/studentpages/studentNewPortfolio/PortfolioIndex.jsx"),
  EditStudentPortfolioIndex: lazyLoad("pages/studentpages/studentEditPortfolio/EditPortfolioIndex.jsx"),
  TemplateIndex:lazyLoad('resume/TemplateIndex.jsx','TemplateIndex'),

  SettingIndex: lazyLoad("pages/commanPages/setting/SettingIndex.jsx"),
  SupportIndex: lazyLoad("pages/studentpages/support/SupportIndex.jsx"),


  TermCondition: lazyLoad("pages/commanPages/termCondition/TermCondition.jsx"),
  PrivacyPolicy: lazyLoad("pages/commanPages/privacyPolicy/PrivacyPolicy"), 
  Logout: lazyLoad("pages/commanPages/logout/Logout.jsx"),
  PaymentStatusView: lazyLoad("pages/poPages/subscriptions/PaymentStatusView.jsx"),

  PlanPricingIndex:lazyLoad("pages/commanPages/setting/planPricing/PlanPricing.jsx")

};
